import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const templateStatusesListRoute: RouteConfig = {
  path: '/',
  name: 'templateEditStatuses',
  component: () =>
    import(/* webpackChunkName: "TemplateStatuses" */ '@/views/mainRoute/template/steps/TemplateStatuses.vue'),
  meta: { title: 'Statusy' },
  beforeEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('status/list', { templateId: tryParseInt(to.params.templateId) }),
      store.dispatch('stage/list')
    ])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.TEMPLATE_CANNOT_LIST_STATUS }));
  }
};
